const adviceListReducer = (state, {action, payload}) => {
    switch (action)
    {
        case 'initAdvices':
            return payload
        case 'addToFavorite':

            return [
                ...state.map( advice => {

                    if( payload === advice.id )
                    {
                        advice.isFavorite = true;
                    }

                    return advice
                })
            ]
        case 'removeFromFavorite':
            return [
                ...state.map( advice => {

                    if( payload === advice.id )
                    {
                        advice.isFavorite = false;
                    }

                    return advice
                })
            ]
        default:
            return state
    }

}

export {adviceListReducer}
